import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import { CKEditor } from '@ckeditor/ckeditor5-react'
import { useEffect, useMemo, useState } from 'react'
import Swal from 'sweetalert2'
import { BaseComponentWithContextProps, componentWithContext } from '../../../../../base/customHooks/componentHOC'
import IPButton from '../../../../../components/IPButton'
import { DealerList, DealerListImportData } from '../models/models'
import { ListDealerApi } from '../services/ListDealerApi'
import { SaveDealerApi } from '../services/SaveDealerApi'
import Table from '../../../../../components/Table'
import IPFile from '../../../../../components/IPFile'
import { excelToJSON } from '../../../../../base/utils/dataHelper'
import IPInput from '../../../../../components/IPInput'

function DailyOrderDealerList(props: BaseComponentWithContextProps) {
  useEffect(() => {
    getList()
  }, [])

  const [list, setList] = useState<DealerList[]>([])
  const [addDealer, setAddDealer] = useState<any>()
  const [dealerFromText, addDealerText] = useState<string>("")

  const getList = async () => {
    props.showLoading()
    const listNotice: ListDealerApi = new ListDealerApi({})

    listNotice
      .listDealers()
      .then((res: any) => {
        props.hideLoading()
        setList(res)
      })
      .catch(err => {
        Swal.fire({
          icon: 'error',
          title: err.description,
          showConfirmButton: true,
          allowOutsideClick: false,
        })
        props.hideLoading()
      })
  }

  const editDealer = async () => {
    const req: DealerListImportData = {
      DealerCode: addDealer,
    }
    const saveNotice: SaveDealerApi = new SaveDealerApi({})
    saveNotice
      .saveDealerApi(req)
      .then((res: any) => {
        props.hideLoading()
        if (res) {
          setList(res)
          Swal.fire({
            icon: 'success',
            title: `Bayi Listesi Güncellenmiştir.`,
            showConfirmButton: true,
            allowOutsideClick: false,
          })
        }
      })
      .catch(err => {
        Swal.fire({
          icon: 'error',
          title: err.description,
          showConfirmButton: true,
          allowOutsideClick: false,
        })
        props.hideLoading()
      })
  }

  const editDealerButton = async () => {
    let data = dealerFromText.split(',')
    const req: DealerListImportData = {
      DealerCode: data,
    }
    const saveNotice: SaveDealerApi = new SaveDealerApi({})
    saveNotice
      .saveDealerApi(req)
      .then((res: any) => {
        props.hideLoading()
        if (res) {
          setList(res)
          addDealerText("")
          Swal.fire({
            icon: 'success',
            title: `Bayi Listesi Güncellenmiştir.`,
            showConfirmButton: true,
            allowOutsideClick: false,
          })
        }
      })
      .catch(err => {
        Swal.fire({
          icon: 'error',
          title: err.description,
          showConfirmButton: true,
          allowOutsideClick: false,
        })
        props.hideLoading()
      })
  }

  const tableColumns = useMemo(
    () => [
      {
        Header: '#',
        accessor: 'count',
      },
      {
        Header: 'Bayi Kodu',
        accessor: 'dealerCode',
      },
      {
        Header: 'Bayi Adı',
        accessor: 'dealerName',
      },
      {
        Header: '',
        accessor: 'x',
      },
    ],
    []
  )

  const tableData = useMemo(
    () =>
      list.map((item, index) => {
        const data = {
          count: index + 1,
          dealerCode: item.DealerCode,
          dealerName: item.DealerName,
        }
        return data
      }),
    [list]
  )

  const handleFiles = async (files: File[]) => {
    const dealerList: any = await excelToJSON(files[0])

    const codeData = dealerList[0].map(item => String(item.BAYİ).trim())

    let list: any[] = []

    codeData.forEach((codeItem, index) => {
      list.push(codeItem)
    })

    setAddDealer(list)
    if (list.length === 0) {
      return Swal.fire({
        icon: 'error',
        title: 'Bayi Bulunamadı!',
        allowOutsideClick: true,
        backdrop: true,
      })
    }
    else {
      editDealer()
    }
  }

  return (
    <div className='container'>
      <div className='content col-lg-12 m-auto'>
        <div className='card'>
          <div className='card-header d-flex justify-content-between'>
            <span className='h4'>Günlük Sipariş Raporu Kullanmayan Bayi Listesi</span>
          </div>
          <div className='card-body'>
            <div className='row'>
              <div className='col-lg-2'>
                <IPFile
                  id='FileInputDealerCode'
                  multiple={false}
                  handleFiles={e => handleFiles(e)}
                  className='campaignFileInput'
                  label="Excel'den Yükle"
                  removeAfterSelect={true}
                />
              </div>
              <div className='col-lg-2'>
                <a className='campaignExcelBtn' href='/assetWeb/docs/dailyReportDealer.xlsx' target='_blank'>
                  Örnek Excel
                </a>
              </div>
            </div>
            <div className='row'>
              <div className='col-lg-6'>
                <IPInput
                  type={'text'}
                  value={dealerFromText}
                  placeholder='Bayi Giriniz'
                  onChange={(e) => {
                    addDealerText(e.target.value)
                  }}
                />
                <label style={{ color: 'red' }}>Virgül ile ayırınız.</label>
              </div>
              <div className='col-lg-3'>
                <IPButton text={'Kaydet'}
                  onClick={editDealerButton}
                />
              </div>
            </div>
            <div className='row'>
              <Table columns={tableColumns} data={tableData} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default componentWithContext(DailyOrderDealerList)
